<template>
  <div
    class="standard-input-container"
    :class="{
      'focus': labelFocus || hasValue,
      'invalid': !valid,
      'textarea': type === 'textarea',
    }"
  >
    <template v-if="type !== 'textarea'">
      <label
        class="standard-input-label"
        :class="{
          'search-field': type === 'search',
          'icon': icon,
        }"
        :for="name"
      >
        {{ labelText }}
      </label>
      <div class="standard-input-wrapper">
        <slot />
        <input
          v-if="name === 'phone'"
          @focus="onInputFocus()"
          @blur="onInputBlur()"
          @input="onInput($event.target.value)"
          class="standard-input"
          :class="{
            'search-field': type === 'search',
            'icon': icon,
          }"
          :autocomplete="autocomplete"
          :type="type"
          :value="value"
          :name="name"
          v-mask="maskOptions"
          :maxlength="maxlength"
        >
        <input
          v-else
          :ref="name"
          @focus="onInputFocus()"
          @blur="onInputBlur()"
          @input="onInput($event.target.value)"
          class="standard-input"
          :class="{
            'search-field': type === 'search',
            'icon': icon,
          }"
          :autocomplete="autocomplete"
          :type="type"
          :value="value"
          :name="name"
          :maxlength="maxlength"
        >
      </div>
      <span
        class="standard-input-info"
        v-if="(!infoMode && !valid) || infoMode"
      >
        {{ info }}
      </span>
    </template>
    <template v-else>
      <label
        class="standard-textarea-label"
        :for="name"
      >
        {{ labelText }}
      </label>
      <textarea
        class="standard-textarea"
        :value="value"
        :name="name"
        :rows="rows"
        @focus="onInputFocus()"
        @blur="onInputBlur()"
        @input="onInput($event.target.value)"
      />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: () => '',
      type: String,
    },
    info: {
      default: () => '',
      type: String,
    },
    type: {
      default: () => 'text',
      type: String,
    },
    minlength: {
      default: () => 0,
      type: Number,
    },
    required: {
      default: false,
      type: Boolean,
    },
    name: {
      default: () => '',
      type: String,
    },
    autocomplete: {
      default: () => '',
      type: String,
    },
    value: {
      default: () => '',
      type: [String, Number],
    },
    valid: {
      default: true,
      type: Boolean,
    },
    infoMode: {
      default: false,
      type: Boolean,
    },
    rows: {
      default: () => 1,
      type: Number,
    },
    icon: {
      default: false,
      type: Boolean,
    },
    maxlength: {
      default: () => 255,
      type: Number,
    },
    autofocus: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      labelFocus: false,
      maskOptions: {
        mask: ['999 999 999', '+99 999 999 999'],
        placeholder: '',
        greedy: true,
      },
    };
  },
  computed: {
    hasValue() {
      return !!this.value;
    },
    labelText() {
      if (this.required) {
        return `${this.label} *`;
      }
      return this.label;
    },
  },
  methods: {
    onInputFocus() {
      this.labelFocus = true;
      this.$emit('input_focus');
    },
    onInputBlur() {
      this.$emit('input_blur');
      this.labelFocus = false;
    },
    onInput(value) {
      this.labelFocus = true;
      if (this.type === 'number') {
        let inputValue = value;
        if (inputValue.length >= 7) {
          inputValue = parseInt(inputValue.toString().slice(0, 7), 10);
        }
        this.$emit('input_change', inputValue);
      } else {
        this.$emit('input_change', value);
      }
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$refs[this.name].focus();
    }
  },
};
</script>
